(function($) {
	'use strict';

	$('[data-tooltip]').tooltip();

})($jq);
